import { z } from 'zod';
import { adminAuditFieldsSchema } from './IAdminAudit';

export const roomSchema = adminAuditFieldsSchema.extend({
    id: z.number().default(-1),
    name: z.string().default(''),
    description: z.string().nullable().optional().default(''),
});

export type IRoom = z.infer<typeof roomSchema>;
